import React, { useCallback } from 'react';
import classNames from 'classnames';
import { IndicatorsTooltip } from './IndicatorsTooltip';
import classes from './styles/index.module.scss';
import { closeActiveTooltip, TooltipBtn } from '../../../../ReactSharedScripts/components/TooltipBtn';
import { EllipsisV } from '../../../../ReactSharedScripts/components/Icons/EllipsisV';

const IndicatorsOptions = ({ indicators, tempSelectedItems, onTempChange, onChange, disabled }) => {
	const indicatorButtonClassNames = classNames(classes.control_round, classes.options__button);
	const handleApplyButtonClick = useCallback(() => {
		onChange();
		closeActiveTooltip();
	}, [onChange]);

	return (
		<TooltipBtn
			tooltip={
				<IndicatorsTooltip
					indicators={indicators}
					tempSelectedItems={tempSelectedItems}
					onTempChange={onTempChange}
					onApplyButtonClick={handleApplyButtonClick}
				/>
			}
			tooltipPosition='bottom'
			tooltipAlign='end'
			className={indicatorButtonClassNames}
			overlay={false}
			hasTooltipIcon={false}
			icon={<EllipsisV />}
			styledButton
			onClose={onChange}
			disabled={disabled}
		/>
	);
};

export default IndicatorsOptions;
